import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { CREATABLE_KINDS, IDEA_KIND_ICON, IDEA_KIND_LABEL } from "@/lib/tilbudsarbeidsrom/idea-board";
import type { OfferIdeaCardKind } from "@/lib/db-types";

interface IdeaBoardToolbarProps {
  busy: boolean;
  undoCount: number;
  onAddCard: (kind: OfferIdeaCardKind) => void;
  onAddGroup: () => void;
  onUndo: () => void;
}

/** Verktøylinjen over Idé-tavlen: nye kort, ny gruppe og angre sletting. */
export function IdeaBoardToolbar({ busy, undoCount, onAddCard, onAddGroup, onUndo }: IdeaBoardToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="toolbar" aria-label="Legg til på tavlen">
      {CREATABLE_KINDS.map((kind) => (
        <Button key={kind} type="button" variant="outline" size="sm" disabled={busy} onClick={() => onAddCard(kind)}>
          <SrIcon name={IDEA_KIND_ICON[kind]} className="w-4 h-4" />
          {IDEA_KIND_LABEL[kind]}
        </Button>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={onAddGroup}>
        <SrIcon name="group" className="w-4 h-4" />
        Gruppe
      </Button>
      {undoCount > 0 && (
        <Button type="button" variant="ghost" size="sm" className="ml-auto" onClick={onUndo}>
          <SrIcon name="undo-2" className="w-4 h-4" />
          Angre sletting{undoCount > 1 ? ` (${undoCount})` : ""}
        </Button>
      )}
    </div>
  );
}
